import React from "react";
import { Navigate } from 'react-router-dom';

import EasyRouter from "react-router-easy";

import Targets from "./targets";
import ELink from "./elink";
import useENavigate from "./enavigate";
import EasyLayout, { Dialog } from "./easyLayout";
import NotFound from "./notfound";

export { Targets, ELink, useENavigate, NotFound, Dialog };

var CURLAYOUT = undefined;

var EasyHandler = function EasyHandler(props) {
    if (!props.newRoute.url && !props.oldRoute) {
        return React.createElement(Navigate, { to: props.defaultPage || 'Index', replace: true });
    } else {
        if (CURLAYOUT && CURLAYOUT.props.newRoute.url === props.newRoute.url) {
            return CURLAYOUT;
        } else {
            CURLAYOUT = React.createElement(EasyLayout, props);
            return CURLAYOUT;
        }
    }
};

var EasyCore = function EasyCore(props) {
    return React.createElement(
        EasyRouter,
        { config: {
                onChange: function onChange(newRoute, oldRoute) {}
            } },
        React.createElement(EasyHandler, props)
    );
};

export default EasyCore;